import { groupBy, mapValues } from 'lodash'
import { IFacetOption, IFacetGroup } from '../types/facets'

export function groupedFacetOptions(
  options: IFacetOption[],
  id: string
): IFacetGroup[] {
  const groupOptions = groupBy(options, option => option.group ?? '')
  const groupedOptionsToFilterOptions = mapValues(
    groupOptions,
    (options, groupLabel) => {
      const ungroupedSizes = id === 'size' && !groupLabel

      return {
        label: ungroupedSizes ? 'Other sizes' : groupLabel,
        options: options.map(option => ({
          label: option.label,
          value: option.id,
        })),
      }
    }
  )
  const filterOptions = Object.values(groupedOptionsToFilterOptions)
  return filterOptions
}
